import type { ReactNode } from "react";
import type { IncludedIcon } from "../site";

export type IconName = IncludedIcon | "phone" | "whatsapp" | "pin" | "external";

const STROKE: Record<Exclude<IconName, "whatsapp">, ReactNode> = {
  shelter: (
    <>
      <path d="M3 10.4 12 4l9 6.4" />
      <path d="M5.6 9.6V20h12.8V9.6" />
      <path d="M10 20v-4.6h4V20" />
    </>
  ),
  power: <path d="M13.2 2.5 5.4 13.4h5.3L10 21.5l8.6-11.2h-5.5l.1-7.8Z" />,
  vehicle: (
    <>
      <path d="M4 16.4v-3.6l1.9-4.3A2 2 0 0 1 7.7 7.3h8.6a2 2 0 0 1 1.8 1.2l1.9 4.3v3.6" />
      <path d="M4 16.4h16" />
      <circle cx="7.6" cy="16.4" r="1.6" />
      <circle cx="16.4" cy="16.4" r="1.6" />
      <path d="M6.4 12.7h11.2" />
    </>
  ),
  parking: (
    <>
      <rect x="3.6" y="3.6" width="16.8" height="16.8" rx="1.4" />
      <path d="M10 16.6V7.6h2.9a2.7 2.7 0 0 1 0 5.4H10" />
    </>
  ),
  security: (
    <>
      <path d="M12 3.2 19 6v5.4c0 4.1-2.9 7.4-7 8.4-4.1-1-7-4.3-7-8.4V6l7-2.8Z" />
      <path d="m9.1 11.9 2 2.1 3.8-4" />
    </>
  ),
  operator: (
    <>
      <path d="M4.4 14.2v-1.9a7.6 7.6 0 0 1 15.2 0v1.9" />
      <path d="M4.4 13.2h2.2v5.1H5.8a1.4 1.4 0 0 1-1.4-1.4v-3.7Z" />
      <path d="M19.6 13.2h-2.2v5.1h.8a1.4 1.4 0 0 0 1.4-1.4v-3.7Z" />
      <path d="M17.4 18.3a3 3 0 0 1-3 2.5h-1.6" />
    </>
  ),
  phone: (
    <path d="M6.4 3.6h3l1.5 3.7-1.9 1.4a11 11 0 0 0 5.3 5.3l1.4-1.9 3.7 1.5v3a1.8 1.8 0 0 1-2 1.8C10.3 17.8 6.2 13.7 4.6 5.6a1.8 1.8 0 0 1 1.8-2Z" />
  ),
  pin: (
    <>
      <path d="M12 21.2c3.8-4.5 5.7-7.8 5.7-10.1a5.7 5.7 0 1 0-11.4 0c0 2.3 1.9 5.6 5.7 10.1Z" />
      <circle cx="12" cy="10.8" r="2.2" />
    </>
  ),
  external: (
    <>
      <path d="M14 4.8h5.2V10" />
      <path d="M19.2 4.8 10.6 13.4" />
      <path d="M17 14.2v4a1.8 1.8 0 0 1-1.8 1.8H6a1.8 1.8 0 0 1-1.8-1.8V9a1.8 1.8 0 0 1 1.8-1.8h4" />
    </>
  ),
};

// Marca registrada: se dibuja con relleno para respetar el trazo original.
const WHATSAPP = (
  <path
    fill="currentColor"
    d="M12 2.4a9.5 9.5 0 0 0-8.2 14.3L2.4 21.6l5.1-1.3A9.5 9.5 0 1 0 12 2.4Zm0 1.9a7.6 7.6 0 0 1 6.1 12.2 7.6 7.6 0 0 1-9.9 2.1l-.4-.2-3 .8.8-2.9-.2-.4A7.6 7.6 0 0 1 12 4.3Zm-3.3 4c-.2 0-.4 0-.6.3-.2.3-.8.8-.8 1.9s.8 2.2.9 2.4c.1.2 1.6 2.6 4 3.5 2 .8 2.4.6 2.8.6.4 0 1.4-.5 1.6-1.1.2-.6.2-1.1.1-1.2l-.5-.3-1.5-.7c-.2-.1-.4-.1-.5.1l-.7.9c-.1.2-.3.2-.5.1a6 6 0 0 1-1.8-1.1 6.9 6.9 0 0 1-1.3-1.6c-.1-.2 0-.4.1-.5l.4-.5.2-.4v-.4l-.7-1.6c-.2-.4-.4-.4-.5-.4h-.7Z"
  />
);

export function Icon({ name, className }: { name: IconName; className?: string }) {
  const isBrand = name === "whatsapp";

  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      width="24"
      height="24"
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke={isBrand ? "none" : "currentColor"}
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {isBrand ? WHATSAPP : STROKE[name]}
    </svg>
  );
}
